import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { MapPin, Clock, Star, ChefHat, Award, Globe } from 'lucide-react';
import Carousel from '../components/Carousel';
import './Home.css';

const Home = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="home-page">
      {/* Hero Section - Premium and Elegant */}
      <section className="hero-section hero-premium">
        <div className="hero-content hero-centered">
          <div className="hero-text fade-in-up">
            <p className="hero-subtitle-premium">
              {t('home.subtitlePremium')}
            </p>
            <h1 className="hero-title-premium">
              Pacific 91
            </h1>
            <p className="hero-tagline-premium">
              {t('home.taglinePremium')}
            </p>
          </div>
        </div>
      </section>

      {/* Quick Info Cards */}
      <section className="quick-info-section section">
        <div className="quick-info-grid">
          <div className="info-card glass-card">
              <MapPin className="info-icon" />
              <h3>{t('home.location.title')}</h3>
              <p>{t('home.location.address')}</p>
              <span className="info-detail">{t('home.locationDetail')}</span>
          </div>
          
          <div className="info-card glass-card">
              <Clock className="info-icon" />
              <h3>{t('home.hours.title')}</h3>
              <p>{t('home.openDays')}</p>
              <span className="info-detail" style={{ whiteSpace: 'pre-line' }}>{t('home.openHours')}</span>
          </div>
          
          <div className="info-card glass-card">
              <Award className="info-icon" />
              <h3>{t('home.specialties.title')}</h3>
              <p>{t('home.buffetType')}</p>
              <span className="info-detail">{t('home.startingPrice')}</span>
          </div>
        </div>
      </section>

      {/* Cuisine Showcase */}
      <section className="cuisine-showcase section">
        <div className="showcase-header">
          <h2>{t('home.cuisine.title')}</h2>
          <div className="section-divider"></div>
          <p className="showcase-description">
            {t('home.cuisine.description')}
          </p>
        </div>

        <div className="cuisine-grid">
          <div className="cuisine-category">
            <div className="cuisine-card" style={{"--bg": "url('/images/WechatIMG193.jpg')"}}>
              <div className="cuisine-overlay"></div>
              <div className="cuisine-info">
                <ChefHat className="cuisine-icon" />
                <h3>{t('home.cuisine.asian.title')}</h3>
                <p>{t('home.cuisine.asian.description')}</p>
              </div>
            </div>
          </div>

          <div className="cuisine-category">
            <div className="cuisine-card" style={{"--bg": "url('/images/WechatIMG192.jpg')"}}>
              <div className="cuisine-overlay"></div>
              <div className="cuisine-info">
                <Globe className="cuisine-icon" />
                <h3>{t('home.cuisine.mediterranean.title')}</h3>
                <p>{t('home.cuisine.mediterranean.description')}</p>
              </div>
            </div>
          </div>

          <div className="cuisine-category">
            <div className="cuisine-card" style={{"--bg": "url('/images/WechatIMG184.jpg')"}}>
              <div className="cuisine-overlay"></div>
              <div className="cuisine-info">
                <Star className="cuisine-icon" />
                <h3>{t('home.cuisine.european.title')}</h3>
                <p>{t('home.cuisine.european.description')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* News Section */}
      <section className="news section">
        <div className="news-inner">
          <div className="news-media">
            <video autoPlay muted loop playsInline className="news-video">
              <source src="/images/labubu.mov" type="video/mp4" />
            </video>
          </div>
          <div className="news-content">
            <h2>Actualité</h2>
            <p>Venez vivre un moment inoubliable : des Labubu géants vous accompagnent pour une expérience fun et familiale au restaurant !</p>
          </div>
        </div>
      </section>

      {/* Experience Section */}
      <section className="experience-section section">
        <div className="experience-content">
          <div className="experience-text">
            <h2>{t('home.experience.title')}</h2>
            <div className="section-divider"></div>
            <p className="experience-description">
              {t('home.experience.description')}
            </p>
            <button 
              className="ocean-btn-secondary"
              onClick={() => navigate('/about')}
            >
              {t('home.cta.discover')}
            </button>
          </div>
          
          <div className="experience-gallery">
            <div className="gallery-main">
              <img src="/images/WechatIMG196.jpg" alt="Expérience Unique" />
            </div>
            <div className="gallery-side">
              <img src="/images/WechatIMG183.jpg" alt="Ambiance" />
              <img src="/images/WechatIMG182.jpg" alt="Service" />
            </div>
          </div>
        </div>
      </section>

      {/* Restaurant Gallery Section */}
      <section className="restaurant-gallery-section section">
        <div className="restaurant-gallery-container">
          <h2 className="section-title">{t('home.gallery.title')}</h2>
          <p className="section-subtitle">{t('home.gallery.subtitle')}</p>
          
          <Carousel 
            images={[
              { src: "/images/WechatIMG194.jpg", alt: "Salle principale" },
              { src: "/images/WechatIMG187.jpg", alt: "Buffet" },
              { src: "/images/WechatIMG188.jpg", alt: "Desserts" },
              { src: "/images/WechatIMG195.jpg", alt: "Ambiance" },
              { src: "/images/WechatIMG184.jpg", alt: "Cuisine ouverte" },
              { src: "/images/WechatIMG185.jpg", alt: "Vue d'ensemble" }
            ]}
            autoPlay={true}
            autoPlayInterval={4000}
          />
        </div>
      </section>
    </div>
  );
};

export default Home;